(() => {
  const roots = document.querySelectorAll('[data-eight-story-alt]');
  roots.forEach((root) => {
    const progress = root.querySelector('[data-reading-progress]');
    const updateProgress = () => {
      if (!progress) return;
      const start = root.offsetTop;
      const range = Math.max(root.offsetHeight - window.innerHeight, 1);
      const value = Math.min(Math.max((window.scrollY - start) / range, 0), 1);
      progress.style.transform = `scaleX(${value})`;
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();

    const shareButton = root.querySelector('[data-share-story]');
    const shareStatus = root.querySelector('[data-share-status]');
    shareButton?.addEventListener('click', async () => {
      try {
        if (navigator.share) {
          await navigator.share({ title: document.title, url: window.location.href });
          if (shareStatus) shareStatus.textContent = 'Share sheet opened.';
        } else {
          await navigator.clipboard.writeText(window.location.href);
          if (shareStatus) shareStatus.textContent = 'Story link copied.';
        }
      } catch (error) {
        if (error?.name !== 'AbortError' && shareStatus) shareStatus.textContent = 'Copy the page address to share this story.';
      }
    });

    root.querySelectorAll('details').forEach((details) => {
      const summary = details.querySelector('summary');
      const sync = () => summary?.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      details.addEventListener('toggle', sync);
      sync();
    });
  });
})();
